import script from "./BottomLineTip.vue?vue&type=script&setup=true&lang=js"
export * from "./BottomLineTip.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__